/* eslint-disable react/jsx-indent */
import { find, get } from "lodash";
import { MDBSpinner } from "mdbreact";
import moment from "moment";
import { createForm, createFormField } from "rc-form";
import React, { Component } from "react";
import InputMask from "react-input-mask";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import Alert from "~/components/common/atoms/Alert";
import PKHBtn from "~/components/common/atoms/Button";
import Modal from "~/components/common/molecules/Modal";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";
import history from "~/history";
import * as p from "~/store/patient/patientAction";
import * as pf from "~/store/patientForm/patientFormAction";
import * as t from "~/store/totalData/actions";
import * as cts from "~/utils/constants";
import * as fnc from "~/utils/func";
import styles from "./style.module.scss";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const ChoosePatientDesktop = Loadable({
  loader: () => import("~/components/desktop/pages/ChoosePatient"),
  loading: LoadableLoading
});

class DetectChoosePatient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowModalCheckInsurance: false,
      isShowModalOverAge: false,
      isShowModalAge: false,
      isShowModalSubject: false
    };
  }

  componentDidMount() {
    const {
      handleGetPatientList,
      resetModalChoosePatient,
      resetModalConfirmPatient,
      patientExam,
      selectPatientFromData,
      isDirectionBack,
      patient,
      resetErrorCheckInsurance,
      serviceType,
      addNewsSubject,
      schedulesSelected
    } = this.props;
    const { scanInsuranceSuccess } = patient;

    if (addNewsSubject && schedulesSelected.length > 1) {
      this.methods.handleContinueAction();
    }

    if (scanInsuranceSuccess) {
      this.methods.handleContinueAction();
    } else {
      if (
        patientExam &&
        (serviceType === cts.SERVICE_TYPE_INSURANCE || serviceType === "BOTH")
      ) {
        // console.log("luồng tái khám");
        this.props.selectPatientReExam();
      } else {
        // console.log("luồng khác");
        this.toggleModalCheckInsurance(false);
      }
    }

    handleGetPatientList();
    resetModalChoosePatient();
    resetModalConfirmPatient();
    resetErrorCheckInsurance();
    // setInsuranceChoice("");

    if (patientExam !== null) {
      selectPatientFromData(patientExam);
      if (isDirectionBack) {
        this.methods.handleGoBack();
      }
    }

    this.props.changeUrlRedirectAfterCreatePatient("/chon-ho-so");
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { patient, patientExam } = this.props;

    if (
      patient.formCheckInsurance !== nextProps.patient.formCheckInsurance &&
      patientExam
    ) {
      this.toggleModalCheckInsurance(true);
    }
  }

  componentDidUpdate = prevProps => {
    const { isShowModalCheckInsurance } = this.state;
    const { patient } = this.props;
    const errorCheckInsurance = get(patient, "errorCheckInsurance");
    if (errorCheckInsurance && !isShowModalCheckInsurance) {
      this.toggleModalCheckInsurance(true);
      this.props.resetErrorCheckInsurance();
    }
  };

  componentWillUnmount() {
    const { selectedFeature } = this.props;
    if (selectedFeature.type !== cts.FEATURE_TYPES.examresult) {
      this.props.resetModalChoosePatient();
      this.props.resetStatusScanQrCodeInsurance();
      this.toggleModalCheckInsurance(false);
    }
  }

  methods = {
    handleContinueAction: () => {
      const {
        serviceType,
        partnerId,
        patient: { selectedPatient },
        selectedFeature,
        requiredCheckInsurance
      } = this.props;

      const routePush = url => {
        const route = fnc.routerByPartnerId(url, partnerId);
        history.push(route);
      };

      switch (selectedFeature.type) {
        case cts.FEATURE_TYPES.examresult: {
          const url_examresult = "/tra-ket-qua-kham-benh-nhidonghcm";
          routePush(url_examresult);
          break;
        }

        default: {
          if (selectedPatient.warningMessage) {
            this.setState({
              isShowModalOverAge: true
            });
          } else {
            if (cts.HospitalStepOnePatient.includes(partnerId)) {
              this.props.getBookingTree("", partnerId);
              break;
            } else {
              // kiểm tra có chọn BHYT
              if (serviceType === cts.SERVICE_TYPE_INSURANCE) {
                // kiểm tra có bắt buộc BHYT hay không ?
                if (partnerId !== "choray" && requiredCheckInsurance) {
                  // hiển thị modals
                  this.checkInsurance();
                } else {
                  // đi bước kế tiếp
                  this.onNextStep();
                }
              } else {
                this.onNextStep();
              }
              break;
            }
          }
        }
      }
    },
    handleCreateNewPatient: () => {
      history.push("/tao-moi-ho-so");
    },
    handleGoBack: () => {
      const {
        partnerId,
        isScheduleWithoutDate,
        goBackStep,
        resetSchedule
      } = this.props;
      if (isScheduleWithoutDate) {
        resetSchedule();
        goBackStep("calendar");
      } else {
        if (partnerId === "umc") {
          history.push("/");
        } else {
          const route = fnc.routerByPartnerId("/chon-lich-kham", partnerId);
          history.push(route);
        }
      }
    }
  };

  deletePatientCallback = () => {
    this.props.handleToggleModalConfirm();
    this.props.handleGetPatientList();
    this.props.handleToggleModalChoosePatient();
    window.scrollTo(0, 0);
  };

  hideAlertInfo = () => {
    this.props.onHideAlertInfo();
  };

  checkInsurance = () => {
    const { patient } = this.props;
    const insuranceCode = get(patient, "selectedPatient.insuranceCode");
    const birthdate = get(patient, "selectedPatient.birthdate");
    if (!!insuranceCode && moment(birthdate, "DD/MM/YYYY").isValid()) {
      this.props.checkInsuranceOfPatient(
        this.onNextStep,
        cts.CHECK_WITH_INSURANCE_CODE_EXIST
      );
    } else {
      this.props.handleToggleModalChoosePatient();
      this.toggleModalCheckInsurance(true);
    }
  };

  onNextStep = () => {
    const { getBookingTree, partnerId } = this.props;
    getBookingTree(null, partnerId);

    // const { partnerId, serviceType } = this.props;
    // let route = "";
    // if (serviceType === "NO_INSURANCE_ONLY") {
    //   route = fnc.routerByPartnerId("/xac-nhan-thong-tin", partnerId);
    // } else {
    //   if (partnerId === "leloi") {
    //     route = fnc.routerByPartnerId(
    //       "/huong-dan-bao-hiem-y-te-dung-tuyen",
    //       partnerId
    //     );
    //   } else {
    //     route = fnc.routerByPartnerId("/xac-nhan-thong-tin", partnerId);
    //   }
    // }
    // history.push(route);
  };

  renderOverMaxModal = () => {
    const { toggleModalNotification, isOverMaxModal } = this.props;
    return (
      <Modal
        title="Thông báo!"
        modal={isOverMaxModal}
        iconTitle={<i className="fal fa-bell" />}
        children="Bạn chỉ được phép tạo tối đa 10 hồ sơ."
        centered
        className="centered"
        toggle={toggleModalNotification}
      />
    );
  };

  renderDeletePatientModal = () => {
    const {
      patient: { showModalConfirm },
      handleDeletePatient,
      handleToggleModalConfirm
    } = this.props;
    return (
      <Modal
        backdropClassName="backdrop_centered"
        modal={showModalConfirm}
        title="Thông báo"
        iconTitle={<i className="fal fa-bell" />}
        children={
          <span style={{ color: "red" }}>
            Bạn có chắc muốn xóa bệnh nhân này!
          </span>
        }
        centered
        className="centered"
        footer
        footerConfirm="true"
        cancelText="Đóng"
        okText="Xác nhận"
        onCancel={handleToggleModalConfirm}
        onOk={() => handleDeletePatient(this.deletePatientCallback)}
        toggle={handleToggleModalConfirm}
      />
    );
  };

  renderCheckInsuranceModal = () => {
    const { patientExam, partnerId } = this.props;
    const stepOne = fnc.getStepFollowTreeMap("service", partnerId);
    return (
      <Modal
        modal={this.state.isShowModalCheckInsurance}
        title="Cập nhật thông tin"
        iconTitle={<i className="fal fa-bell" />}
        children={this.renderBodyModalCheckInsurance()}
        centered
        noBackDrop={patientExam && false}
        className="centered"
        toggle={() => {
          patientExam
            ? history.push(stepOne)
            : this.toggleModalCheckInsurance(false);
        }}
      />
    );
  };

  renderBodyModalCheckInsurance = () => {
    const {
      form: { getFieldProps, getFieldError },
      serviceTypeDefault,
      partnerId,
      extraConfig
    } = this.props;

    const isMobile = fnc.checkDevice();

    const fieldFullName = getFieldError("fullName");
    const fullNameMessage = fieldFullName ? fieldFullName.join(", ") : null;

    const fieldInsuranceCode = getFieldError("code");
    const insuranceCodeMessage = fieldInsuranceCode
      ? fieldInsuranceCode.join(", ")
      : null;
    const fieldBirhtday = getFieldError("birthday");
    const birthdayMessage = fieldBirhtday ? fieldBirhtday.join(", ") : null;

    const stepOne = fnc.getStepFollowTreeMap("service", partnerId);

    const quet_bhyt_btn = get(extraConfig, "quet_bhyt_btn", false);

    return (
      <div>
        <span>Vui lòng nhập thông tin y tế: </span>
        <div className={styles.form_insurance}>
          <div className={styles.form_group}>
            <label htmlFor="label_fullname">
              Họ và tên<sup>*</sup>
            </label>
            <input
              className="form-control"
              {...getFieldProps("fullName", {
                trigger: ["onChange"],
                rules: [
                  {
                    required: true,
                    message: "Vui lòng nhập họ tên"
                  }
                ]
              })}
              type="text"
              disabled
            />
          </div>
          {fullNameMessage && (
            <span className={styles.red}>{fullNameMessage}</span>
          )}
          <div className={styles.form_group}>
            <label htmlFor="label_code">
              Mã BHYT<sup>*</sup>
            </label>
            <input
              className="form-control"
              {...getFieldProps("code", {
                trigger: ["onChange"],
                rules: [
                  {
                    required: true,
                    message: "Vui lòng nhập mã số BHYT"
                  }
                ]
              })}
              placeholder="CHxxxxxxxxxxxxxxxx"
              type="text"
            />
          </div>
          {insuranceCodeMessage && (
            <span className={styles.red}>{insuranceCodeMessage}</span>
          )}
          <React.Fragment>
            <div className={styles.form_group}>
              <label htmlFor="label_birthday">
                Ngày tháng năm sinh<sup>*</sup>
              </label>
              <InputMask
                className="form-control"
                {...getFieldProps("birthday", {
                  rules: [{ validator: this.validatorBirthday }]
                })}
                mask="99/99/9999"
                type="text"
              />
            </div>
            {birthdayMessage && (
              <span className={styles.red}>{birthdayMessage}</span>
            )}
          </React.Fragment>
        </div>

        {isMobile && quet_bhyt_btn && (
          <p
            className={styles.url_scan_qr_code}
            onClick={() => history.push("/check-bhyt")}
          >
            Quét mã BHYT
          </p>
        )}

        <p style={{ fontSize: "13px", fontStyle: "italic" }}>
          ***Nếu bạn không có BHYT vui lòng chọn{" "}
          <strong>"Tôi không có thẻ BHYT"</strong>.
        </p>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <PKHBtn
            onClick={
              serviceTypeDefault === cts.SERVICE_TYPE_INSURANCE
                ? () => history.push(stepOne)
                : async () => {
                    await this.props.changeServiceType(
                      cts.SERVICE_TYPE_NO_INSURANCE
                    );
                    this.onNextStep();
                  }
            }
          >
            Tôi không có thẻ BHYT
          </PKHBtn>
          <PKHBtn
            create="create"
            pd35="pd35"
            onClick={this.handleCheckInsurance}
          >
            Tiếp tục
          </PKHBtn>
        </div>
        <div id="reader" className={styles.screen_scan} />
      </div>
    );
  };

  toggleModalCheckInsurance = status => {
    this.setState({
      isShowModalCheckInsurance: status
    });
    if (!status) {
      this.props.selectPatientFromList(0);
      this.props.resetErrorCheckInsurance();
    }
    this.props.resetStatusScanQrCodeInsurance();
  };

  validatorBirthday = (rule, value, cb) => {
    if (!moment(value, "DD/MM/YYYY").isValid()) {
      cb("Vui lòng nhập đúng định dạng ngày tháng");
    } else {
      cb();
    }
  };

  handleCheckInsurance = () => {
    this.props.form.validateFields((error, value) => {
      if (!error) {
        this.props.checkInsuranceOfPatient(this.onNextStep);
      }
    });
  };

  toggleModalOverAge = () => {
    this.setState({
      isShowModalOverAge: !this.state.isShowModalOverAge
    });
  };

  renderOverAgeModal = () => {
    const {
      patient: { selectedPatient }
    } = this.props;

    return (
      <Modal
        modal={this.state.isShowModalOverAge}
        title="Thông báo"
        iconTitle={<i className="fal fa-bell" />}
        children={selectedPatient.warningMessage}
        centered
        className="centered"
        toggle={this.toggleModalOverAge}
      />
    );
  };

  render() {
    const {
      patient: { isAlertInfo, alertMsg },
      // bookingTree,
      patientExam,
      serviceType,
      loading
    } = this.props;

    if (
      patientExam !== null &&
      !(serviceType === cts.SERVICE_TYPE_INSURANCE || serviceType === "BOTH")
    ) {
      return <Redirect to="/xac-nhan-thong-tin" />;
    }

    if (loading) {
      return (
        <div className="loading">
          <MDBSpinner big />
        </div>
      );
    }
    return (
      <React.Fragment>
        <ChoosePatientDesktop {...this.props} {...this.methods} />

        <Alert
          isModal={isAlertInfo}
          message={alertMsg}
          toggleAlert={this.hideAlertInfo}
        />
        {this.renderOverMaxModal()}
        {this.renderDeletePatientModal()}
        {this.renderCheckInsuranceModal()}
        {this.renderOverAgeModal()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    patientForm: { redirectToPatientUpdate, isModal: isOverMaxModal },
    patient,
    features: { selectedFeature, featureListBooking, selectedFeatureBooking },
    user: { IsAuthenticated },
    totalData: {
      bookingTree,
      partnerId,
      isDirectionBack,
      subject: { name: subjectName },
      service: { serviceType, serviceTypeDefault, requiredCheckInsurance },
      days: { bookingDate },
      isScheduleWithoutDate,
      addNewsSubject,
      schedulesSelected,
      loading
    },
    followUpExam: { patientExam }
  } = state;

  return {
    loading,
    schedulesSelected,
    addNewsSubject,
    requiredCheckInsurance,
    subjectName,
    device: type,
    redirectToPatientUpdate,
    isOverMaxModal,
    patient,
    selectedFeature,
    featureListBooking,
    selectedFeatureBooking,
    IsAuthenticated,
    bookingTree,
    partnerId,
    patientExam,
    isDirectionBack,
    serviceType,
    serviceTypeDefault,
    bookingDate,
    isScheduleWithoutDate
  };
};

const mapDispatchToProps = dispatch => ({
  getBookingTree: () => {
    dispatch(t.getBookingTree());
  },
  selectPatientReExam: () => {
    dispatch(p.selectPatientReExam());
  },
  onHideAlertInfo: () => {
    dispatch(p.hideAlertInfoChoosePatient());
  },
  handleGetPatientList: () => {
    dispatch(p.getPatientList());
  },
  handleGetPatientDetail: id => {
    dispatch(pf.getPatientDetail(id));
  },
  handleToggleModalConfirm: () => {
    dispatch(p.toggleModalConfirm());
  },
  handleDeletePatient: deletePatientCallback => {
    dispatch(p.deletePatient(deletePatientCallback));
  },
  handleToggleModalChoosePatient: () => {
    dispatch(p.toggleModalChoosePatient());
  },
  toggleModalNotification: () => {
    dispatch(pf.createPatientOverMaxCloseModal());
  },
  resetModalChoosePatient: () => {
    dispatch(p.resetModalChoosePatient());
  },
  resetModalConfirmPatient: () => {
    dispatch(p.resetModalConfirmPatient());
  },
  resetSelectedPatient: () => dispatch(p.updateSelectedPatient({})),
  changeUrlRedirectAfterCreatePatient: url => {
    dispatch(pf.changeUrlRedirectAfterCreatePatient(url));
  },
  selectPatientFromData: patient => {
    dispatch(p.selectPatientFromData(patient));
  },
  saveFieldsCheckInsurance: fields => {
    dispatch(p.saveFieldsCheckInsurance(fields));
  },
  checkInsuranceOfPatient: (cb, text = "") => {
    dispatch(p.checkInsuranceOfPatient(cb, text));
  },
  resetFormCheckInsurance: () => {
    dispatch(p.resetFormCheckInsurance());
  },
  changeServiceType: type => {
    dispatch(t.changeServiceType(type));
  },
  selectHospital: partnerid => {
    dispatch(t.selectHospital(partnerid));
  },
  resetErrorCheckInsurance: () => {
    dispatch(p.resetErrorCheckInsurance());
  },
  resetStatusScanQrCodeInsurance: () => {
    dispatch(p.resetStatusScanQrCodeInsurance());
  },
  selectPatientFromList: id => {
    dispatch(p.selectPatientFromList(id));
  },
  setInsuranceChoice: id => {
    dispatch(t.setInsuranceChoice(id));
  },
  goBackStep: status => {
    dispatch(t.goBackStep(status));
  },
  resetSchedule: () => {
    dispatch(t.resetSchedule());
  }
});

const DetectChoosePatientHelmet = withTitle({
  component: DetectChoosePatient,
  title: `${hospitalName.value} | Chọn hồ sơ bệnh nhân`
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    createForm({
      mapPropsToFields: props => {
        const {
          patient: { formCheckInsurance }
        } = props;
        return {
          fullName: createFormField(formCheckInsurance.fullName),
          code: createFormField(formCheckInsurance.code),
          birthday: createFormField(formCheckInsurance.birthday)
        };
      },
      onFieldsChange(props, fields) {
        let code = fields.code;
        if (code !== undefined) {
          code = { ...code, value: code.value.toUpperCase().trim() };
          props.saveFieldsCheckInsurance({ code });
        } else {
          props.saveFieldsCheckInsurance(fields);
        }
      }
    })(DetectChoosePatientHelmet)
  )
);
